// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signing-table-container {

}
.signing-table-container > div {
    display: inline;
}
.enrollment-package-viewer .enrollment-progress-stepper {
    margin-top: 20px;
    margin-bottom: 20px;
}

table.signing-table {
    margin: 10px auto;
    border-collapse: collapse;
}
table.signing-table thead {
    font-weight: bold;
}

table.signing-table tr td {
    border: 1px solid black;
    padding: 5px 20px;
}
table.signing-table tr td div {
    margin: 3px 0;
}
table.signing-table .info {
    margin: 3px 0 5px -3px;
}

.signing-table-footer {
    margin: 0 auto;
    text-align: right;
}


.signing-table-footer button {
    padding: 10px 20px;
    margin: 0 5px;
}

iframe {
    margin: 10px 0;
}



.family-enrolment-warning {
    width: 450px;
    margin: 0 auto;
    padding: 20px;
}

.signing-table-footer .info {
    width: 450px;
    text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/PDFGeneration/EnrollmentPackageViewer.css"],"names":[],"mappings":"AAAA;;AAEA;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;;;AAIA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".signing-table-container {\n\n}\n.signing-table-container > div {\n    display: inline;\n}\n.enrollment-package-viewer .enrollment-progress-stepper {\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\ntable.signing-table {\n    margin: 10px auto;\n    border-collapse: collapse;\n}\ntable.signing-table thead {\n    font-weight: bold;\n}\n\ntable.signing-table tr td {\n    border: 1px solid black;\n    padding: 5px 20px;\n}\ntable.signing-table tr td div {\n    margin: 3px 0;\n}\ntable.signing-table .info {\n    margin: 3px 0 5px -3px;\n}\n\n.signing-table-footer {\n    margin: 0 auto;\n    text-align: right;\n}\n\n\n.signing-table-footer button {\n    padding: 10px 20px;\n    margin: 0 5px;\n}\n\niframe {\n    margin: 10px 0;\n}\n\n\n\n.family-enrolment-warning {\n    width: 450px;\n    margin: 0 auto;\n    padding: 20px;\n}\n\n.signing-table-footer .info {\n    width: 450px;\n    text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
